import * as React from 'react';

import ForgotPasswordCtrl from '@webapp/controllers/registration/forgot-password';

import MotionOpacity from '@components/motion/motion-opacity';

interface ForgotPasswordStartPageProps {
  className?: string;
}

export const ForgotPasswordStartPage: React.FC<ForgotPasswordStartPageProps> = (
  props
) => {
  return (
    <MotionOpacity className={props.className}>
      <ForgotPasswordCtrl />
    </MotionOpacity>
  );
};

export default ForgotPasswordStartPage;
